import React from 'react';
import './App.css';
import ElevateAppBar from './components/ElevatedAppBar';
import HeaderOne from './components/Header';
import { ThreeColSection } from './components/3ColSection';
import { Tratamientos } from './components/Tratamientos';
import { Galeria } from './components/Galeria';
import { Contacto } from './components/Contacto';
import { Instalaciones } from './components/Instalaciones';
import { Footer } from './components/Footer';

function App() {
  return (
    <div className="App">
      <ElevateAppBar>
        <HeaderOne></HeaderOne>
        <ThreeColSection></ThreeColSection>
        <Tratamientos></Tratamientos>
        <Instalaciones></Instalaciones>
        <Galeria></Galeria>
        <Contacto></Contacto>
        <Footer></Footer>
      </ElevateAppBar>
    </div>
  );
}

export default App;
